// src/components/adminpanel/AdminLogin.js
import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaUser, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import backImage from "../../assets/back.jpg";



const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${backImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const LoginForm = styled(motion.form)`
  font-family: "Inter", sans-serif;
  background: rgba(48, 136, 139, 0.15); /* Glass effect */
  backdrop-filter: blur(12px);
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;


const InputField = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: 12px 50px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
    outline: none;
    transition: all 0.3s ease-in-out;

    &:focus {
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 0px 12px rgba(255, 255, 255, 0.4);
    }

    &::placeholder {
      font-weight: normal;
      color: rgba(46, 42, 42, 0.7);
    }
  }

  svg {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: rgba(46, 42, 42, 0.7);
  }
`;

const Button = styled(motion.button)`
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
    transform: scale(1.05);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const Title = styled.h2`
  font-size: 28px;
  margin-bottom: 25px;
  color: #333;
`;

const BackButton = styled(motion.button)`
  margin-top: 20px;
  background: transparent;
  border: 2px solid #4facfe;
  color: #4facfe;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.3s ease;

  &:hover {
    background: #4facfe;
    color: white;
  }
`;


function AdminLogin() {
  const [adminUser, setAdminUser] = useState("");
  const [adminPass, setAdminPass] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post("https://server229256.nazwa.pl/admin-login", {
        username: adminUser,
        password: adminPass,
      });
  
      const { success, token, user } = response.data;
  
      if (!success || !token || !user) {
        toast.error("Błąd danych logowania.");
        return;
      }
  
      // 🔍 Log received role
      console.log("👤 Received role:", `"${user.userRole}"`);
  
      // ✅ Normalize and verify role
      const normalizedRole = user.userRole?.trim().toUpperCase();
      if (!["SUPERADMIN", "INFLUENCER"].includes(normalizedRole)) {
        toast.error("Brak uprawnień do panelu administratora.");
        return;
      }
  
      toast.success("Zalogowano jako administrator");
      localStorage.setItem("adminToken", token);
      localStorage.setItem("adminUser", JSON.stringify(user));
      localStorage.setItem("lastLogin", new Date().toISOString());
      navigate("/adminpanel/dashboard");
    } catch (err) {
      toast.error("Błąd logowania administratora.");
    } finally {
      setIsLoading(false);
    }
  };
  
  

  return (
    <LoginContainer>
      <ToastContainer />
      <LoginForm
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        onSubmit={handleAdminLogin}
      >
        <Title>🔐 Logowanie administratora</Title>


        <InputField>
          <FaUser />
          <input
            type="text"
            placeholder="Nazwa administratora"
            value={adminUser}
            onChange={(e) => setAdminUser(e.target.value)}
            required
          />
        </InputField>

        <InputField>
          <FaLock />
          <input
            type="password"
            placeholder="Hasło administratora"
            value={adminPass}
            onChange={(e) => setAdminPass(e.target.value)}
            required
          />
        </InputField>

        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Logowanie..." : "Zaloguj się"}
        </Button>
        <BackButton
  type="button"
  onClick={() => navigate("/login")}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  ⬅ Powrót do logowania użytkownika
</BackButton>

      </LoginForm>
    </LoginContainer>
  );
}

export default AdminLogin;
